<script setup>
import {
  nextTick, onMounted, ref, watch,
} from 'vue';

const props = defineProps({
  // Array de calificaciones cada una con su definición y cada definición con su tipo_nota
  calificaciones: { type: Array, required: true },
});

const slickWrapper = ref();

/* global $ */
function conectarSlick() {
  const itemsPublicosSlick = $(slickWrapper.value);
  itemsPublicosSlick.slick({
    slidesToShow: 4,
    slidesToScroll: 2,
    infinite: false,
  });

  // const stHeight = $('.slick-track').height();
  // $('.slick-slide').css('height', `${stHeight}`);
  // $('.competencia-descripcion').css('height', '100%');

  itemsPublicosSlick.css('display', 'none').css('visibility', 'visible').fadeIn();
  $('.slick-list').css('overflow', 'hidden');
}

watch(() => props.calificaciones, () => {
  const itemsPublicosSlick = $(slickWrapper.value);
  itemsPublicosSlick.slick('unslick');
  nextTick(() => {
    conectarSlick();
  });
});

onMounted(() => {
  conectarSlick();
});
</script>

<template>
  <div class="row">
    <div
      ref="slickWrapper"
      class="col-xs-12"
      style="visibility: hidden"
    >
      <div
        v-for="cal in calificaciones"
        :key="cal.id"
        class="item-publico-nota"
      >
        <div class="nombre">{{ cal.definicion.nombre }}</div>
        <div class="descripcion">{{ cal.definicion.descripcion }}</div>
        <div class="nota">
          {{ cal.valor_final }}
          <span
            v-if="cal.recuperacion?.valor_final"
            v-tooltip="$t('Recuperacion')"
            class="recuperacion"
          >
            {{ cal.recuperacion.valor_final }}
          </span>
        </div>
        <div class="leyenda">
          {{ cal.valor_final_nombre || cal.definicion.tipo_nota.leyenda }}
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import '@/components/cuadernos/constantes_cuaderno.scss';
.item-publico-nota {
  height: 120px;
  border: 1px $dark-gray solid;
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 10px;
  margin-top: 5px;
  background-color: $gray;
  cursor: all-scroll;
  display: flex;
  flex-direction: column;
  padding: 5px 10px;

  .nombre {
    font-weight: bold;
  }
  .descripcion {
    font-size: 0.8em;
    height: 30px;
    overflow: hidden;
  }
  .nota {
    flex: 1;
    margin: auto;
    font-size: 2em;
    font-weight: bold;
  }
  .recuperacion {
    margin-left: 15px;
  }
  .leyenda {
    text-align: right;
    font-size: 0.8em;
  }
}
</style>
